import React from 'react';
import Icon from './Icon';
import Reveal from './Reveal';
import './WhatsNew.css';

const POINTS = [
  {
    icon: 'layers',
    title: 'One super-app, not five',
    text: 'BikesFood, BikesGroceries, delivery, cargo and campus errands have always lived in separate apps, or no app at all. BikesDrop is the first Ghanaian platform to bring them under one roof.',
  },
  {
    icon: 'zap',
    title: 'Standby Mode for riders',
    text: 'Instead of waiting for a single assigned job, riders can go on standby and swipe through nearby delivery requests in real time, giving them more choice and more earning potential.',
  },
  {
    icon: 'mapPin',
    title: 'True two-leg live tracking',
    text: 'Every order shows live distance and ETA for both rider-to-pickup and pickup-to-drop off, not just a static estimate stamped at checkout.',
  },
  {
    icon: 'bookOpen',
    title: 'Campus-first errands',
    text: 'Built with hostels, lecture halls and campus gates in mind, students and staff can send an errand without leaving their block.',
  },
  {
    icon: 'shoppingBag',
    title: 'Market women, digitised',
    text: 'Through BikesFood and BikesGroceries, food vendors, market women and neighbourhood shops can start taking digital orders without building an app or hiring riders of their own.',
  },
  {
    icon: 'fileText',
    title: 'Transparent, published policies',
    text: 'Customers, riders and merchants each have a clear, public policy governing how the platform treats them, with no fine print hidden behind a login.',
  },
];

export default function WhatsNew() {
  return (
    <section className="whats-new section" id="why">
      <div className="container">
        <Reveal className="whats-new__head">
          <span className="eyebrow eyebrow--amber">New to the Ghanaian Market</span>
          <h2 className="section-heading">What BikesDrop brings that didn&rsquo;t exist before</h2>
          <p className="section-sub">
            We studied how logistics and e-commerce actually work on the ground in Ghana, then built
            for the gaps everyone else left open.
          </p>
        </Reveal>

        <div className="whats-new__grid">
          {POINTS.map((p, i) => (
            <Reveal delay={i * 60} className="whats-new__card" key={p.title}>
              <span className="whats-new__icon">
                <Icon name={p.icon} size={20} />
              </span>
              <div>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
